import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";

export const getPartners = async (urlParams) => {

    const url = new URL(process.env.NEXT_PUBLIC_API_URL + '/wp/v2/partners')
    url.search = new URLSearchParams(urlParams).toString();

    const result =  await fetch(url, { next: { revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE) } })
    const jsonResult = await result.json()

    return {
        data: jsonResult,
        total: result.headers.get('X-WP-Total')
    }
}

export const getPartner = async (slug) => {
    const result =  await fetch(process.env.NEXT_PUBLIC_API_URL + '/wp/v2/partners?slug=' + slug, { next: { revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE) } })

    return await result.json()
}